export default "__VITE_ASSET__DFUzi2$U__"